import * as XLSX from "xlsx";
import { getJsDateFromExcel } from "excel-date-to-js";

export default function useImportExcel() {

  const validateFileCount = (files, count) => {
    const fileCount = files.length;
    const fileNames = files.map(file => file.name).join(", ");

    if (fileCount > count) {
      return { isError: true, message: fileNames };
    } else {
      return { isError: false, message: "" };
    }
  };

  const validateFileType = (file) => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (file.type != fileType) {
      return { isError: true, message: file.name };
    } else {
      return { isError: false, message: "" };
    }
  }

  const readFileContent = async (file, startWith, maxDataLength, condition) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = () => {
        try {
          const arrayBuffer = fileReader.result;
          let data = new Uint8Array(arrayBuffer);
          let arr = [];
          for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          let bstr = arr.join("");
          let workbook = XLSX.read(bstr, { type: "binary" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];

          const rawDatas = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false, raw: true });
          const rawDatasWithOutHeader = rawDatas.filter((item, index) => index >= startWith - 1);

          if (rawDatasWithOutHeader.length == 0) {
            resolve({ data: [], success: false, message: "data 0 row", code: "001" });
          } else if (rawDatasWithOutHeader.length > maxDataLength) {
            resolve({ data: [], success: false, message: `data more than ${maxDataLength}`, code: "002" });
          } else {
            let result = [];

            rawDatasWithOutHeader.forEach(rawData => {
              let newObj = {};
              let errorResult = [];
              for (let i = 0; i <= condition.length; i++) {
                let errorObj = {}
                if (condition.length == i) {
                  newObj.error = errorResult;
                } else {
                  let data = rawData[i];
                  if (data === undefined || data === null) {
                    if ('type' in condition[i] && (condition[i].type == "integer" || condition[i].type == "decimal")) {
                      data = 0;
                    } else {
                      data = "";
                    }
                  }
                  if ('isRequire' in condition[i]) {
                    if (condition[i].isRequire === true && data.toString().trim() === "") {
                      errorObj.field = condition[i].name;
                      errorObj.type = "blank";
                      errorObj.data = data;
                      errorResult.push(errorObj)
                    }
                  }
                  if ('isUnique' in condition[i]) {
                    if ('type' in condition[i] && condition[i].type === "taxId" &&  (data.toString().trim() === "-" || data.toString().trim() === "0000000000000")) {
                      data = data.toString();
                    } else if (!validateDuplicate(rawDatasWithOutHeader, i, data)) {
                      errorObj.field = condition[i].name;
                      errorObj.type = "duplicate";
                      errorObj.data = data;
                      errorResult.push(errorObj)
                    }
                  }
                  if ('wordLength' in condition[i]) {
                    if ((data).length > condition[i].wordLength) {
                      errorObj.field = condition[i].name;
                      errorObj.type = "overflow";
                      errorObj.wordLength = condition[i].wordLength
                      errorResult.push(errorObj)
                    }
                  }
                  if ('type' in condition[i]) {
                    let type = condition[i].type;
                    if ((type === "string" && !validateString(data.toString()))
                      || (type === "integer" && !validateInteger(data))) {
                      errorObj.field = condition[i].name;
                      errorObj.type = "invalid";
                      errorObj.data = data;
                      errorResult.push(errorObj)
                    } else if ((type === "date" && !validateDate(data) && (('isRequire' in condition[i] && condition[i].isRequire === true) || data !== ""))) {
                      errorObj.field = condition[i].name;
                      errorObj.type = "format";
                      errorObj.data = data;
                      errorResult.push(errorObj)
                    } 
                    else {
                      if (type === "string") {
                        data = data.toString();
                      } else if (type === "date" && data !== "") {
                        data = formatDateToISOString(convertDate(data));
                      } 
                    }
                  }
                  newObj[condition[i].name] = data;
                }
              }
              result.push(newObj);
            });
            resolve({ data: result, success: true, message: "", code: "200" });
          }
        } catch (error) {
          resolve({ data: [], success: false, message: error, code: "888" });
        }
      };

      fileReader.onerror = () => {
        reject(new Error("File reading error."));
      };
    });
  };

  const validateString = (value) => {
    return typeof value === 'string';
  }

  const formatDateToISOString = (value) => {
    const day = value.getDate();
    const month = value.getMonth() + 1;
    let year = value.getFullYear();

    // return year.toString() + '-' + month.toString().padStart(2,'0') + '-' + day.toString().padStart(2,'0');
    return day.toString().padStart(2,'0') + '/' + month.toString().padStart(2,'0') + '/' + year.toString() ;
  }

  const validateInteger = (value) => {
    return !isNaN(parseInt(value, 10)) && Number.isInteger(Number(value));
  }

  const validateYearEn = (value) => {
    let text = /^[0-9]+$/;
    if (value && value.length == 4) {
      if (value != 0) {
        if (value != "" && !text.test(value)) {
          return false;
        }
        let current_year = new Date().getFullYear(); //2023
        let current_yearTh = new Date().getFullYear() + 543; //2566
        if (value - current_year > 500 || value >= current_yearTh) {
          return false;
        }
        return true;
      }
    }
    return false;
  }
  const validateYearTh = (value) => {
    let text = /^[0-9]+$/;
    if (value && value.length == 4) {
      if (value != 0) {
        if (value != "" && !text.test(value)) {
          return false;
        }
        let current_year = new Date().getFullYear() + 543;
        let next_year = current_year + 1;
        if (value < 2464 || value > next_year) {
          //ค.ศ. 1920
          return false;
        }
        return true;
      }
    }
    return false;
  }

  const getDaysInMonth = (year, month) => {
    // month เริ่มจาก 0 (มกราคม) ถึง 11 (ธันวาคม)
    return new Date(year, month, 0).getDate();
  }

  const validateDate = (value) => {
    let result = true;
    if (value.toString().includes("/")) {
      if (value.length !== 10) {
        result = false;
        return result;
      }
      let dateSplit = value.split("/");
      let day = dateSplit[0];
      let month = dateSplit[1];
      let year = dateSplit[2];
      let checkYear = validateYearTh(year);
      if (!checkYear) {
        result = false;
      } else if (month <= 0 || month > 12) {
        result = false;
      } else {
        const daysInMonth = getDaysInMonth(year, month);
        if (day <= 0 || day > daysInMonth) {
          result = false;
        }
      }
    } else {
      if (!validateInteger(value)) {
        result = false;
      } else {
        let convertData = getJsDateFromExcel(value);
        // console.log("validateInteger=",value);
        // console.log("convertData=",convertData);        
        if (convertData !== "Invalid Date") {
          let year = convertData.getFullYear().toString();
          let checkYear = validateYearTh(year);
          if (!checkYear) {
            result = false;
          }
        } else {
          result = false;
        }
      }
    }
    return result;
  }

  const convertDate = (value) => {
    let date = new Date();
    if (value.toString().includes("/")) {
      let dateSplit = value.split("/");
      let day = dateSplit[0];
      let month = dateSplit[1];
      let year = dateSplit[2];
      date = new Date(year, month - 1, day);
    } else {
      date = getJsDateFromExcel(value);
    }
    return date;
  }


  const validateDuplicate = (arrayOfObjects, i, data) => {
    const duplicates = [];
    arrayOfObjects.forEach((obj) => {
      const current = obj[i];
      duplicates.push(current);
    });
    return duplicates.filter(item => item === data).length <= 1;
  }

  const getFields = (input, field) => {
    let output = [];
    for (let i = 0; i < input.length; ++i) output.push(input[i][field]);
    return output;
  };

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };


  return {
    validateFileCount,
    validateFileType,
    readFileContent,
    getFields,
    removeDuplicates,
    validateDate,
    convertDate,
  }
}